import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="relative flex min-h-full items-center justify-center overflow-hidden bg-background px-4 py-12">
      <div
        aria-hidden
        className="absolute inset-0 -z-10 opacity-30 blur-3xl"
        style={{
          background:
            'radial-gradient(60% 60% at 50% 40%, rgba(255,47,47,0.35) 0%, rgba(138,67,225,0.35) 45%, rgba(213,17,253,0.2) 80%, transparent 100%)',
        }}
      />
      <Outlet />
    </div>
  );
}
